import React from 'react';
import SeoHead from '@components/SeoHead';
import { getPageBySlug } from '@lib/content';

interface StaticPageProps {
  slug: string;
}

const StaticPage: React.FC<StaticPageProps> = ({ slug }) => {
  const page = getPageBySlug(slug);

  if (!page) {
    return <p className="muted">Page not found.</p>;
  }

  return (
    <>
      <SeoHead title={page.title} description={page.excerpt} pageSlug={slug} url={`/${slug}`} />
      <div className="container" style={{ paddingTop: '2rem', position: 'relative', zIndex: 1 }}>
        <article className="page-section">
          <div className="prose" dangerouslySetInnerHTML={{ __html: page.html }} />
        </article>
      </div>
    </>
  );
};

export default StaticPage;
